var App = App || {};

App.MemberHighlights = (() => {
    'use strict';

    const init = (id) => {
        if (id.length) {
            const carousel = document.getElementById(id).querySelector('.splide');
            const modal = document.getElementById(`${id}-modal`);
            const img = document.getElementById(`${id}-testimonial-img`);

            if (carousel) {

                const splide = new Splide(carousel, {
                    type: 'loop',
                    arrows: true,
                    pagination: false,
                    padding: { right: '50px', left: '20px' },
                    fixedWidth: '72.604%',
                    gap: '20px',
                    mediaQuery: 'max',
                    breakpoints: {
                        575: {
                            fixedWidth: '94.25%',
                            gap: '10px',
                            padding: { right: '50px', left: '10px' },
                        }
                    }
                });

                splide.on('mounted', function () {

                    document.getElementById(id).querySelectorAll('a.testimonial').forEach(testimonial => {
                        testimonial.addEventListener('click', e => {
                            e.preventDefault();
                            openModal(modal, testimonial);
                        });
                    });

                    modal.addEventListener('hidden.bs.modal', () => {
                        modal.querySelector('.modal-body').innerHTML = '';
                    });

                    splide.on('move', function (newIndex, prevIndex, destIndex) {
                        let newSlide = splide.Components.Slides.getAt(newIndex);
                        updateImg(img, newSlide.slide.querySelector('.testimonial').dataset.img);
                    });
                });

                splide.mount();
            }
        }
    }

    const updateImg = ((img, imgSrc) => {
        if (imgSrc.length) {
            img.src = imgSrc;
        }
        else {
            img.src = img.dataset.default;
        }
    });

    const openModal = ((modal, testimonial) => {
        let video = testimonial.dataset.video;
        let transcript = testimonial.dataset.transcript;
        let modalBody = modal.querySelector('.modal-body');
        let bsModal = new bootstrap.Modal(modal);

        modalBody.innerHTML = `<iframe src="${video.split('?')[0]}?autoplay=1&rel=0" class="testimonial__video-embed" title="Video testimonial" allow="autoplay"></iframe>`;

        if (transcript.length) {
            modalBody.innerHTML += `<div class="testimonial__video-transcript"><a href="${transcript}">Transcript</a></div>`;
        }

        bsModal.show();
    });

    return {
        init: init
    };
})();